import css from 'styled-jsx/css';

const styles = css.global`.blog-image .img-container {
  position: relative;
  height: 252px;
  width: 100%;
  margin-bottom: 48px;
}

.blog-image .img-container .mobile {
  display: block;
}

.blog-image .img-container .desktop {
  display: none;
}

.blog-image amp-img img {
  object-fit: cover;
}

.img-container.ampless {
  overflow: hidden;
}

.img-container.ampless img {
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: block;
  height: 0;
  max-height: 100%;
  max-width: 100%;
  min-height: 100%;
  min-width: 100%;
  width: 0;
  margin: auto;
}

@media (min-width: 992px) {
  .blog-image .img-container .mobile {
    display: none;
  }

  .blog-image .img-container .desktop {
    display: block;
  }

  .blog-image .img-container {
    height: 252px;
    width: 492px;
  }

  .img-container.ampless img {
    object-fit: cover;
  }
}
`;

export default styles;